import * as types from './types';

export const resetStore = () => ({type: types.RESET_STORE, payload: {}});
export const login = () => ({type: types.LOGIN, payload: {}});
export const logout = () => ({type: types.LOGOUT, payload: {}});
export const addNotification = (notification, timeout = 3000) => ({type: types.ADD_NOTIFICATION, payload: {notification, timeout}});
export const removeNotification = id => ({type: types.REMOVE_NOTIFICATION, payload: {id}});
